<template>
  <div id="section-button">
    <button @click="btnAction">{{ btnText }}</button>
  </div>
</template>

<script>
  export default {
    name: 'section-button',
    props: ['btnText'],
    data () {
      return {
      }
    },
    methods: {
      btnAction() {
        console.log(this);
        this.$router.push('build');
      }
    }
  }
</script>

<style scoped lang="sass">
  #section-button
    text-align: center
    button
      text-transform: uppercase
      color: #606060
      font-weight: 700
      padding: 15px 30px
      border-radius: 2px
      border: none
      border-bottom: 3px solid #a7a9af
      box-shadow: 0 10px 20px rgba(0,0,0,.2)
      @media screen and (max-width: 767px)
        padding: 10px 20px
</style>



// WEBPACK FOOTER //
// SectionButton.vue?8a8fde48